import React, { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { defineMessages } from 'react-intl.macro';

import FilterList, { FilterListProps } from 'core/Filters/FilterList';
import { keyBy, map } from 'lodash';

const messages = defineMessages({
  delivered: {
    id: 'components.v2.FilterMessageStatus.delivered',
    defaultMessage: 'Delivered',
  },
  sent: {
    id: 'components.v2.FilterMessageStatus.sent',
    defaultMessage: 'Sent',
  },
  undelivered: {
    id: 'components.v2.FilterMessageStatus.undelivered',
    defaultMessage: 'Undelivered',
  },
  sentHelpText: {
    id: 'components.v2.FilterMessageStatus.sentHelpText',
    defaultMessage: 'The message was sent, but we haven’t received updated delivery information.',
  },
});

export interface FilterMessageStatusProps extends Omit<FilterListProps, 'classes' | 'items' | 'allItems'> {}

const FilterMessageStatus: React.FC<FilterMessageStatusProps> = ({ ...rest }) => {
  const { formatMessage } = useIntl();

  const items: any[] = useMemo(
    () =>
      map(['delivered', 'sent', 'undelivered'], (id: keyof typeof messages) => ({
        id,
        name: formatMessage(messages[id]),
        helpText: id === 'sent' && formatMessage(messages.sentHelpText),
      })),
    [formatMessage],
  );
  const allItems = useMemo(() => keyBy(items, 'id'), [items]);

  return <FilterList items={items} allItems={allItems} {...rest} />;
};

export default FilterMessageStatus;
